export const theme = {
  colors: {
    text: '#000',
    textGrey: '#555',
    background: '#fff',
    backgroundGrey: '#cdd4e7',
    primary: '#07c',
    secondary: '#05a',
    accent: '#609',
    muted: '#f6f6f6',
  },
  space: [0, 2, 4, 8, 16, 32, 64, 128, 256],
  fonts: {
    body: 'Roboto, sans-serif',
    heading: 'Roboto, sans-serif',
    monospace: 'Roboto, sans-serif',
  },
  fontSizes: {
    xs: 12,
    s: 14,
    m: 16,
    l: 20,
    xl: 26,
    xxl: 32,
  },
  fontWeights: {
    normal: 400,
    bold: 700,
  },
  lineHeights: {
    body: 1.5,
    heading: 1.125,
  },
  borders: {
    none: 'none',
    normal: '1px solid',
  },
  radii: {
    none: '0',
    normal: '5px',
    small: '3px',
    round: '50%',
  },
};
